<script lang="ts">
  import type { Storefront } from '@shared/types/Storefront';
  import Icon from '@shared/svelte/Components/Icon.svelte';
  export let storefront : Storefront;
  export let callbacks: any;

  function closeClick() {
    preppedErrors = [];
    storefront.errors = {};
  }

  let preppedErrors = [];

  const errorTypes = {
    header_image_id: {
      label: 'Header & Logo',
      section: 'Header & Logo',
    },
    logo_image_id: {
      label: 'Header & Logo',
      section: 'Header & Logo',
    },
    storefront_featured_products: {
      label: 'Featured Products',
      section: 'Featured Product',
    },
    featured_items: {
      label: 'Product Pair',
      section: 'Product Pair',
    }

  };

  function goToSection(section: any) {
    callbacks.setActiveSection(section)
  }

  function prepErrors() {
    preppedErrors = [];
    Object.keys(storefront.errors).forEach(function(key) {
      preppedErrors.push({
        key: key,
        message: storefront.errors[key][0],
        linkInfo: errorTypes[key]
      });
    });
  }

  $: {
    if (storefront.errors) {
      prepErrors();
    } else {
      closeClick()
    }
  }
</script>

{#if preppedErrors && preppedErrors.length > 0}
  <!-- svelte-ignore a11y-missing-attribute -->
  <div
    class="form-message ng-animation slide-in-out alert margin-top--smallest
    padding-left--small padding-right--small padding-top--smaller
    padding-bottom--smaller w500 align-center">
    <div class='s5 float-left'><Icon type='Warning' height="20" width="20"></Icon>

    </div>
    <div class='s5'>
      {preppedErrors.length} Storefront Error{#if preppedErrors.length != 1}s{/if}
    </div>
    {#each preppedErrors as error (error)}
      <div>
        <div
          class="alert__close-button light-title--bold"
          on:click={closeClick}>
          x
        </div>
        <div class='s5'>
          <a on:click={() => goToSection(error.linkInfo.section)}
            class='cursor-pointer underline' style='color: white;'>
            {error.linkInfo.label}
          </a>
          {error.message}
        </div>
      </div>
    {/each}
  </div>
{/if}
